import * as tslib_1 from "tslib";
import * as React from 'react';
import { DelayedRender, classNamesFunction, getNativeProps, divProperties } from '../../Utilities';
var getClassNames = classNamesFunction();
/**
 * {@docCategory Announced}
 */
var AnnouncedBase = /** @class */ (function (_super) {
    tslib_1.__extends(AnnouncedBase, _super);
    function AnnouncedBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnouncedBase.prototype.render = function () {
        var _a = this.props, message = _a.message, styles = _a.styles;
        this._classNames = getClassNames(styles);
        return (React.createElement("div", tslib_1.__assign({ role: "status" }, getNativeProps(this.props, divProperties)),
            React.createElement(DelayedRender, null,
                React.createElement("div", { className: this._classNames.screenReaderText }, message))));
    };
    AnnouncedBase.defaultProps = {
        'aria-live': 'assertive'
    };
    return AnnouncedBase;
}(React.Component));
export { AnnouncedBase };
//# sourceMappingURL=Announced.base.js.map